"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalHamburguerMenu_constants_exports = {};
__export(GlobalHamburguerMenu_constants_exports, {
  ANALYZE_ID: () => ANALYZE_ID,
  ASSESS_ID: () => ASSESS_ID,
  ASSIGN_ID: () => ASSIGN_ID,
  EXPLORE_ID: () => EXPLORE_ID,
  MANAGE_ID: () => MANAGE_ID,
  adminLinks: () => adminLinks,
  analyticsIdGenerator: () => analyticsIdGenerator,
  getRoleLinks: () => getRoleLinks,
  internalUserLinks: () => internalUserLinks,
  links: () => links,
  teacherLinks: () => teacherLinks
});
module.exports = __toCommonJS(GlobalHamburguerMenu_constants_exports);
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var EXPLORE_ID = 1;
var ASSIGN_ID = 2;
var ASSESS_ID = 3;
var ANALYZE_ID = 4;
var MANAGE_ID = 5;
var teacherLinks = [{
  id: EXPLORE_ID,
  icon: "book-outline",
  title: "Teach",
  "default": false,
  url: "/explore"
}, {
  id: ASSIGN_ID,
  icon: "assign",
  title: "Assign",
  "default": false,
  url: "/assign"
}, {
  id: ASSESS_ID,
  icon: "published",
  title: "Assess",
  "default": false,
  url: "/assess"
}, {
  id: ANALYZE_ID,
  icon: "reports-graph",
  title: "Analyze",
  "default": false,
  url: "/analyze"
}, {
  id: MANAGE_ID,
  icon: "settings",
  title: "Manage",
  "default": false,
  url: "/manage"
}];
var links = [{
  id: EXPLORE_ID,
  icon: "book-outline",
  title: "Teach",
  "default": false,
  url: "/explore"
}, {
  id: ASSIGN_ID,
  icon: "assign",
  title: "Assign",
  "default": false,
  url: "/assign"
}, {
  id: ASSESS_ID,
  icon: "published",
  title: "Assess",
  "default": false,
  url: "/assess"
}, {
  id: ANALYZE_ID,
  icon: "reports-graph",
  title: "Analyze",
  "default": false,
  url: "/analyze"
}];
var adminLinks = [{
  id: EXPLORE_ID,
  icon: "book-outline",
  title: "Teach",
  "default": false,
  url: "/explore"
}, {
  id: ASSESS_ID,
  icon: "published",
  title: "Assess",
  "default": false,
  url: "/assess"
}, {
  id: ANALYZE_ID,
  icon: "reports-graph",
  title: "Analyze",
  "default": false,
  url: "/analyze"
}, {
  id: MANAGE_ID,
  icon: "settings",
  title: "Manage",
  "default": false,
  url: "/manage"
}];
var internalUserLinks = [{
  id: MANAGE_ID,
  icon: "settings",
  title: "Manage",
  "default": false,
  url: "/manage"
}];
var getRoleLinks = function getRoleLinks2(role) {
  return {
    teacher: teacherLinks,
    "not-role-selected": links,
    "district-admin": adminLinks,
    "school-admin": adminLinks,
    "gm-super-admin": internalUserLinks,
    "gm-dis": internalUserLinks,
    "gm-dcst": internalUserLinks,
    "gm-ps": internalUserLinks
  }[role] || 404;
};
var analyticsIdGenerator = function analyticsIdGenerator2(id) {
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, EXPLORE_ID, "GlobalElementsGlobalHamburgerMenuTeachButton"), ASSIGN_ID, "GlobalElementsGlobalHamburgerMenuAssignButton"), ASSESS_ID, "GlobalElementsGlobalHamburgerMenuAssessButton"), ANALYZE_ID, "GlobalElementsGlobalHamburgerMenuAnalyzeButton"), MANAGE_ID, "GlobalElementsGlobalHamburgerMenuManageButton")[id];
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ANALYZE_ID,
  ASSESS_ID,
  ASSIGN_ID,
  EXPLORE_ID,
  MANAGE_ID,
  adminLinks,
  analyticsIdGenerator,
  getRoleLinks,
  internalUserLinks,
  links,
  teacherLinks
});
//# sourceMappingURL=GlobalHamburguerMenu.constants.js.map